import client from './index';

// import enGB from '@server/i18n/resources/en_GB';
// import zhHK from '@server/i18n/resources/zh_HK';

import enUS from '../../../server/i18n/resources/en-US';
import zhHK from '../../../server/i18n/resources/zh-HK';
import ja from '../../../server/i18n/resources/ja';
import ar from '../../../server/i18n/resources/ar';
import hi from '../../../server/i18n/resources/hi';
import ko from '../../../server/i18n/resources/ko';
import mn from '../../../server/i18n/resources/mn';
import es from '../../../server/i18n/resources/es';

const trasnlations = {
  async getTranslationSource(platform: string, byPass = true) {
    if (typeof window === 'undefined' && byPass) {
      return {
        'zh-HK': zhHK,
        'en-US': enUS,
        'ja': ja,
        'ar': ar,
        "hi": hi,
        "ko": ko,
        "mn": mn,
        "es": es,
      };
    }
    try {
      const response = await client.get('/translation/source', {
        params: {
          platform,
        },
      });
      return {
        'zh-HK': zhHK,
        'en-US': enUS,
        ...response.data,
      };
    } catch (error) {
      return {
        'zh-HK': zhHK,
        'en-US': enUS,
      };
    }
  },
};

export default trasnlations;
